import clsx from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div
      className={clsx(
        'animate-spin rounded-full border-dark-600 border-t-primary-500',
        sizeClasses[size],
        className
      )}
    />
  );
}

/**
 * Bloque de carga con barrido de luz (shimmer). Reemplaza spinners en
 * contenido para evitar layout shift y dar sensación de respuesta.
 * Usa la clase `.skeleton` definida en index.css (respeta reduced-motion).
 */
export function Skeleton({ className }: { className?: string }) {
  return <div className={clsx('skeleton', className)} />;
}

/** Skeleton con forma de card de stat (Dashboard, listados). */
export function StatCardSkeleton() {
  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div className="space-y-3">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-9 w-16" />
        </div>
        <Skeleton className="h-12 w-12 rounded-xl" />
      </div>
      <Skeleton className="h-4 w-28 mt-4" />
    </div>
  );
}

